import { rankingData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function RankingSection() {
  const ref = useScrollReveal();

  const changeIcon = (change: string) => {
    switch (change) {
      case 'up':
        return <i className="ri-arrow-up-fill text-accent-500 text-sm"></i>;
      case 'down':
        return <i className="ri-arrow-down-fill text-foreground-400 text-sm"></i>;
      case 'new':
        return <span className="inline-block text-xs font-bold text-accent-500 bg-accent-100 px-1.5 py-0.5 rounded">NEW</span>;
      default:
        return <span className="w-5 h-5 flex items-center justify-center text-foreground-300 text-xs">─</span>;
    }
  };

  return (
    <section id="ranking" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            下载排行
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            本周最受欢迎的影视资源排行榜
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            {rankingData.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-100 transition-colors cursor-pointer`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-md font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-foreground-950'
                    : item.rank === 2
                    ? 'bg-accent-300 text-foreground-950'
                    : item.rank === 3
                    ? 'bg-accent-200 text-foreground-950'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">
                    {item.type}
                  </div>
                </div>
                <div className="text-xs text-foreground-500 whitespace-nowrap flex-shrink-0">
                  {item.hot}
                </div>
                <div className="flex-shrink-0 w-8 flex justify-center">
                  {changeIcon(item.change)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}